<body>
  <div class="container-fluid h-100">
    <!-- Toasts stack, so a success and an error shown together do not cover each other. The live regions are always
         in the page, so screen readers announce each message when it appears. -->
    <div class="toast-stack">
      <div role="alert">
        @if (showError) {
          <div class="toster error d-flex justify-content-end">
            <div class="toster-wrapper ps-3 d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center justify-content-between">
                <img alt="" width="20" src="assets/icons/toast-error.svg" />
                <div class="content ms-3">
                  <h6 class="mb-0">Error</h6>
                  <p>{{ errorMsg }}</p>
                </div>
              </div>
              <button type="button" class="btn" (click)="showError = false">
                <img alt="Dismiss message" width="18" src="assets/icons/toast-close.svg" />
              </button>
            </div>
          </div>
        }
      </div>
      <div role="status">
        @if (showSuccess) {
          <div class="toster success d-flex justify-content-end">
            <div class="toster-wrapper ps-3 d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center justify-content-between">
                <img alt="" width="20" src="assets/icons/toast-success.svg" />
                <div class="content ms-3">
                  <h6 class="mb-0">Success</h6>
                  <p>{{ successMsg }}</p>
                </div>
              </div>
              <button type="button" class="btn" (click)="showSuccess = false">
                <img alt="Dismiss message" width="18" src="assets/icons/toast-close.svg" />
              </button>
            </div>
          </div>
        }
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</body>
